export * from './object-type.pipe';
export * from './position-extra.pipe';
export * from './month-year-date.pipe';
export * from './capitalize.pipe';
export * from './date-format.pipe';



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/admin/shared/pipes/index.ts